import script from "./AddBookPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBookPage.vue?vue&type=script&setup=true&lang=js"

import "./AddBookPage.vue?vue&type=style&index=0&id=0eade396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eade396"]])

export default __exports__